import React, { useState, useEffect } from "react";
import { Link, Navigate, useParams } from 'react-router-dom';
import './fichaFinanceiro.css'
import { getFirestore, doc, getDoc, updateDoc } from 'firebase/firestore';
import 'firebase/firestore'
function FichaAlterar() {
    const [encaminharClienteCobranca, setEncaminharClienteCobranca] = useState(false);
    const [naoEncaminharClienteCobranca, setNaoEncaminharClienteCobranca] = useState(false);
    const [cobrador, setCobrador] = useState('');
    const [dataEncaminhamento, setDataEncaminhamento] = useState('');
    const [mensagem, setMensagem] = useState('');
    const [sucesso, setSucesso] = useState('');
    const db = getFirestore();
    const { id } = useParams();
    useEffect(() => {
        const fetchData = async () => {
            try {
                console.log('ID do Cliente:', id);
                const clienteDocRef = doc(db, 'clientes', id);
                console.log('Referência do Documento:', clienteDocRef);
                const docSnapshot = await getDoc(clienteDocRef);
                console.log('Snapshot do Documento:', docSnapshot.data());
                if (docSnapshot.exists()) {
                    const dados = docSnapshot.data();
                    setCobrador(dados.cobrador);
                    setEncaminharClienteCobranca(dados.encaminharClienteCobranca);
                    setNaoEncaminharClienteCobranca(dados.naoEncaminharClienteCobranca);
                    setDataEncaminhamento(dados.dataEncaminhamento);

                } else {
                    setMensagem('Cliente não encontrado');
                }
            } catch (error) {
                setMensagem('Erro ao obter dados do cliente');
                console.error('Erro ao obter dados do cliente:', error);
            }
        };
        fetchData();
    }, [db, id]);
    const AlterarCliente = async () => {
        try {
            const senhaDigitada = prompt("Digite sua senha:");
            if (senhaDigitada === '@') {
                await updateDoc(doc(db, 'clientes', id), {
                    cobrador: cobrador,
                    naoEncaminharClienteCobranca: naoEncaminharClienteCobranca,
                    encaminharClienteCobranca: encaminharClienteCobranca,
                    dataEncaminhamento: dataEncaminhamento
                });
                setMensagem('');
                setSucesso('S');
            } else {
                setMensagem('Senha incorreta');
            }
        } catch (erro) {
            setMensagem('Erro ao atualizar cliente');
            setSucesso('N');
            console.error('Erro ao atualizar cliente:', erro);
        }
    };
    const handleOnClick = (event) => {
        AlterarCliente(event);
        window.history.back();
      };
    return (
        <div>
            <div className="background9">
                <form className="box">
                    <div className="title">
                        <h1>
                            Transferir
                        </h1>
                    </div>
                    <div>
                        <div className="caixa-cobrador">
                            <div className="input-group-prendend">
                                <span className="input-group-text">Nome do cobrador:</span>
                            </div>
                            <select className="custom-select d-block" onChange={(e) => setCobrador(e.target.value)} value={cobrador} id="estado" required>
                                <option value="">Nenhum</option>
                                <option value="talita">talita</option>
                                <option value="bruno">bruno</option>
                                <option value="allan">allan</option>
                                <option value="jhow">jhow</option>
                                <option value="ana">ana</option>
                                <option value="karol">karol</option>
                                <option value="alef">alef</option>
                            </select>
                        </div>

                        <div className="divMkt">
                            <h5>
                                Encaminhar cliente?
                            </h5>
                        </div>
                        <div className="encaminhar row">
                            <div className="form-check mb-3">
                                <input onChange={(e) => setEncaminharClienteCobranca(e.target.checked)} checked={encaminharClienteCobranca} className="form-check-input" type="checkbox" id="flexCheckChecked" />
                                <label className="form-check-label" htmlFor="flexCheckChecked">
                                    <b>Sim</b>
                                </label>
                            </div>
                            <div className="form-check mb-3">
                                <input onChange={(e) => setNaoEncaminharClienteCobranca(e.target.checked)} checked={naoEncaminharClienteCobranca} className="form-check-input" type="checkbox" id="flexCheckChecked" />
                                <label className="form-check-label" htmlFor="flexCheckChecked">
                                    <b>Não</b>
                                </label>
                            </div>
                        </div>
                    </div>
                    {mensagem.length > 0 ? <div className="alert alert-danger mt-2" role="alert">{mensagem}</div> : null}
                    {sucesso === 'S' ? <Navigate to='/app/cobrancamapsempresas' /> : null}
                </form>
            </div>
            <div className="voltar row">
                <Link to="/app/cobrancamapsempresas" className="btn btn-warning btn-acao">Voltar</Link>
                <Link to="/app/cobrancamapsempresas" onClick={handleOnClick} type="button" className="btn btn-primary btn-acao">Salvar</Link>
            </div>
        </div>
    );
}

export default FichaAlterar;